// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1HwBR","col":"styles_col__2lOs_"};